/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class externaldata extends IceEntity {
	external_data_key: string = "";
  external_reference_date: any = NaN;
  external_reference_end_date: any = NaN;
  trans_account: string = "";
  provider_trans_account: string = "";
  network_trans_account: string = "";
  network_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  parent_src_type: number = 0;
  src_type: number = 0;
  sub_type: number = 0;
  note_status_type: IceTypes.notestatus = IceTypes.notestatus.statusInitialDraft;
  external_data_type: number = 0;
  patient_intake = false;
  title: string = "";
  original_path: string = "";
  compressed = false;
  secure_flag: string = "";
  cfield_data: string = "";
  file_created: any = NaN;
  file_accessed: any = NaN;
  file_modified: any = NaN;
  file_user: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  gettablename(): string {
    return "EXTERNAL_DATA";
  }
}
